import type { Payment } from 'paintscout'

/**
 * A payment funded by a Wisetack loan. Wisetack payments leave `provider` unset, so `type` is the
 * marker the webhook writes (see handleWisetackPayoutUpdates).
 */
export function isWisetackPayment(payment: Payment): boolean {
  return payment?.type?.toLowerCase() === 'wisetack'
}
